<template>
  <div class="view collection" data-name="collection">
    <ShowcaseHero :title="'Prosecco Collection.'" />
    <CollectionShowcase />
  </div>
</template>

<script>
import ShowcaseHero from '@/components/heros/ShowcaseHero.vue';
import CollectionShowcase from '@/components/contents/CollectionShowcase.vue';

export default {
  name: 'collection',

  components: {
    ShowcaseHero,
    CollectionShowcase,
  },
};
</script>
